import { render, staticRenderFns } from "./ButtonSolidBox.vue?vue&type=template&id=61d15e20&"
import script from "./ButtonSolidBox.vue?vue&type=script&lang=js&"
export * from "./ButtonSolidBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports